import React, {useState, useEffect, useRef} from 'react';
import { useParams } from 'react-router';
import {Link, useNavigate} from 'react-router-dom';
import axios from 'axios';
import '../config.js';

import { theme, formData } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import UserBasicInfo from '../components/userBasicInfo.js';
import UserAdditionalInfo from '../components/userAdditionalInfo.js';
import Progress from '../components/progress.js';

function User(props) {
  const { id, subnav } = useParams();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(()=>{
    axios.get(global.config.api_server+'user?id='+id+'&token='+localStorage.getItem("token")) 
    .then(res => {
      if(res.status === 200 && res.data.status === "success"){
        const currentUser = res.data.user;
        if(currentUser === null || currentUser === undefined){
          navigate("/users");
        }else{
          setUser(currentUser);
          setLoading(false);
        }
      }else{
        alertService.error(res.data.error);
      }
    }).catch(err => {
      alertService.error(err);
      navigate("/users");
    });
  }, []);
  
  const handleDelete = (event) => {
    event.preventDefault();
    if(id){
      axios.get(global.config.api_server+'user?id='+id+'&task=delete&token='+localStorage.getItem("token")).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('User deleted');
          navigate("/users");
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
      });
    }else{
      alertService.error('User ID not found');
    }
  }
  
  const checkSubNav = (param) => {
    let design = "";
    if(subnav === param){
      design = " disabled";
    }else if(param === 'basic' && (subnav === null || subnav === undefined)){
      design = " disabled";
    }
    return design;
  }

  let subnavItem = <UserBasicInfo id={id} user={user}></UserBasicInfo>;
  if(subnav === 'additional'){
    subnavItem = <UserAdditionalInfo id={id} user={user}></UserAdditionalInfo>;
  }
  return(
    <div className="container-fluid">
      {loading === true ? (
        <Progress label='Loading..'/>
      ):
      <div>
        <div className="mb-3">
          <button className={'btn btn-icon-split float-right btn-'+theme()} data-toggle="modal" data-target="#deleteUserModal">
            <span className="icon text-white-50">
              <i className="fas fa-trash"></i>
            </span>
            <span className="text">Delete</span>
          </button>
          <Link to={"/users"} className="btn btn-light btn-icon-split mr-2">
            <span className="icon text-white-50">
              <i className="fas fa-arrow-left"></i>
            </span>
            <span className="text">Back</span>
          </Link>
          <Link to={"/user/"+id} className={'btn btn-icon-split mr-2 btn-'+theme() + checkSubNav('basic')}>
            <span className="icon text-white-50">
              <i className="fas fa-user"></i>
            </span>
            <span className="text">Basic Info</span>
          </Link>
          <Link to={"/user/"+id+"/additional"} className={'btn btn-icon-split mr-2 btn-'+theme() + checkSubNav('additional')}>
            <span className="icon text-white-50">
              <i className="fas fa-user-plus"></i>
            </span>
            <span className="text">Additional Info</span>
          </Link>
        </div>
        
        {subnavItem}
        
        <div className="modal fade" id="deleteUserModal" tabIndex="-1" role="dialog" aria-labelledby="delete-user-popup" aria-hidden="true">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="delete-user-popup">Confirm deletion?</h5>
                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">Are you sure, you want to delete this company?</div>
              <div className="modal-footer">
                <button className="btn btn-default" type="button" data-dismiss="modal">Cancel</button>
                <button className={'btn ml-3 btn-'+theme()} onClick={handleDelete} data-dismiss="modal">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    </div>
  )
}

export default User;